/**
 * Menu Data Validation Utility
 * Ensures 100% structural integrity, unique IDs, category mappings,
 * and valid pricing modes for Whitefield Jalsa Restobar menu dataset.
 */

export function validateMenuData(foodCategories, drinksCategories, foodItems, drinksItems) {
  const errors = [];
  const warnings = [];

  const allCategories = [...foodCategories, ...drinksCategories];
  const allItems = [...foodItems, ...drinksItems];

  const categoryIds = new Set();
  allCategories.forEach((cat) => {
    if (!cat.id) errors.push(`Category missing ID: ${cat.label}`);
    if (!cat.label) errors.push(`Category missing label: ${cat.id}`);
    if (!cat.shortLabel) warnings.push(`Category missing shortLabel: ${cat.id}`);
    if (categoryIds.has(cat.id)) errors.push(`Duplicate category ID found: ${cat.id}`);
    categoryIds.add(cat.id);
  });

  const itemIds = new Set();
  allItems.forEach((item) => {
    if (!item.id) errors.push(`Menu item missing ID: ${item.name}`);
    if (itemIds.has(item.id)) errors.push(`Duplicate item ID found: ${item.id}`);
    itemIds.add(item.id);

    if (!item.name) errors.push(`Menu item missing name: ${item.id}`);
    if (!item.categoryId) {
      errors.push(`Menu item missing categoryId: ${item.id}`);
    } else if (!categoryIds.has(item.categoryId)) {
      errors.push(`Menu item ${item.id} references non-existent categoryId: ${item.categoryId}`);
    }

    if (!item.pricing || !item.pricing.mode) {
      errors.push(`Menu item ${item.id} missing pricing.mode`);
    } else {
      if (item.pricing.mode === "single" && item.pricing.amount === undefined) {
        errors.push(`Single price item ${item.id} missing amount`);
      }
      if (item.pricing.mode === "variants" && (!item.pricing.options || item.pricing.options.length === 0)) {
        errors.push(`Variant pricing item ${item.id} missing options array`);
      }
    }

    if (!item.source || !item.source.verified) {
      warnings.push(`Menu item ${item.id} missing verified source metadata`);
    }
  });

  if (errors.length > 0) {
    console.error("❌ Menu Data Validation Errors:", errors);
  } else {
    console.log(`✅ Menu Data Validation Passed cleanly! (${allItems.length} total items validated across ${allCategories.length} categories)`);
  }

  return { isValid: errors.length === 0, errors, warnings };
}
